/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-props-no-spreading */
import { sanitize as sanitizeHtml } from 'isomorphic-dompurify';

// Use sanitize = true in case you know the data to insert as HTML is not supposed to be executable HTML. For example: JSON LD Data for Rich Text Snippets on Search Engines.
const DangerousWithSanitization = ({
  html = '',
  as: As = 'script',
  sanitize = true,
  openLinksInNewTab = false,
  ...rest
}) => {
  let sanitizedHTML = html;
  if (sanitize) sanitizedHTML = sanitizeHtml(html);
  if (openLinksInNewTab)
    sanitizedHTML = sanitizedHTML.replace(/href/g, "target='_blank' href");
  return <As dangerouslySetInnerHTML={{ __html: sanitizedHTML }} {...rest} />;
};

export default DangerousWithSanitization;
